import {FC, useMemo, useState} from 'react'
import {isAPP} from '../../../_metronic/helpers'
import {InvoiceTypeList} from '../../modules/apps/invoice-management/invoices-list/core/_models'
import {InvoiceEditModal} from '../../modules/apps/invoice-management/invoices-list/invoice-edit-modal/InvoiceEditModal'
import {InvoiceExcelModal} from '../../modules/apps/invoice-management/invoices-list/invoice-excel-modal/InvoiceExcelModal'
import {useAuth} from '../../modules/auth'

const PERSIAN_DIGITS = '۰۱۲۳۴۵۶۷۸۹'
const toPersianDigits = (value: number) =>
  String(value).replace(/\d/g, (digit) => PERSIAN_DIGITS[Number(digit)])

const InvoiceTypeFavDashboard: FC = () => {
  const {currentUser} = useAuth()

  const [invoiceType, setInvoiceType] = useState<number>(0)
  const [title, setTitle] = useState<string>('')
  const [invoiceTemplate, setInvoiceTemplate] = useState<number>(0)
  const [webModalOpen, setWebModalOpen] = useState(false)
  const [newWebModalOpen, setNewWebModalOpen] = useState(false)
  const [excelModalOpen, setExcelModalOpen] = useState(false)

  // The templates starred in the «صورتحساب جدید» window (InvoiceTypeSelectBox), read from the
  // session so a new star shows up here without reloading the page.
  const favorites = useMemo(
    () =>
      (currentUser?.infv || []).flatMap((item) => {
        const type = InvoiceTypeList.find((x) => x.id === Number(item.type))
        const template = type?.template?.find((x) => x.id === Number(item.template))
        return type && template ? [{type, template}] : []
      }),
    [currentUser?.infv]
  )

  const open = (type: number, template: number, setOpen: (value: boolean) => void) => {
    const selectedType = InvoiceTypeList.find((x) => x.id === type)
    if (selectedType) {
      let name = selectedType.name
      if (selectedType.template) {
        name += ' - ' + selectedType.template.find((x) => x.id === template)?.name
      }
      setTitle(name)
      setInvoiceType(type)
      setInvoiceTemplate(template)
      setOpen(true)
    }
  }

  return (
    <div className='mp-quick-invoice'>
      <button
        type='button'
        className='btn btn-primary mp-quick-invoice__new'
        onClick={() => setNewWebModalOpen(true)}
      >
        <i className='las la-plus fs-2' aria-hidden='true' />
        صورتحساب جدید
      </button>

      {favorites.length > 0 ? (
        <section className='mp-quick-invoice__favorites' aria-labelledby='mp-favorite-templates'>
          <h3 id='mp-favorite-templates'>
            <i className='las la-star' aria-hidden='true' />
            الگوهای ستاره‌دار
          </h3>
          <ul>
            {favorites.map(({type, template}) => {
              const typeLabel = `صورتحساب نوع ${toPersianDigits(type.id)}`
              return (
                <li key={`${type.id}-${template.id}`} className='mp-fav-item'>
                  <span
                    className={`mp-fav-item__icon bg-light-${template.color} text-${template.color}`}
                    aria-hidden='true'
                  >
                    <i className={`las ${template.icon}`} />
                  </span>
                  <span className='mp-fav-item__name'>
                    <strong>{template.name}</strong>
                    <small>{typeLabel}</small>
                  </span>
                  <span className='mp-fav-item__actions'>
                    {!isAPP && (
                      <button
                        type='button'
                        className='btn btn-sm btn-light-success'
                        onClick={() => open(type.id, template.id, setExcelModalOpen)}
                        aria-label={`ورود اکسل ${template.name}، ${typeLabel}`}
                      >
                        اکسل
                      </button>
                    )}
                    <button
                      type='button'
                      className='btn btn-sm btn-light-primary'
                      onClick={() => open(type.id, template.id, setWebModalOpen)}
                      aria-label={`فرم وب ${template.name}، ${typeLabel}`}
                    >
                      فرم وب
                    </button>
                  </span>
                </li>
              )
            })}
          </ul>
        </section>
      ) : (
        <p className='mp-quick-invoice__hint'>
          <i className='las la-star' aria-hidden='true' />
          <span>
            الگوهای پرکاربرد را در پنجره «صورتحساب جدید» ستاره‌دار کنید تا همین‌جا با یک کلیک صادر
            شوند.
          </span>
        </p>
      )}

      {webModalOpen && (
        <InvoiceEditModal
          title={{title, setTitle}}
          invoiceType={{invoiceType, setInvoiceType}}
          invoiceTemplate={{invoiceTemplate, setInvoiceTemplate}}
          closeFn={() => {
            setWebModalOpen(false)
          }}
        />
      )}
      {excelModalOpen && (
        <InvoiceExcelModal
          title={{title, setTitle}}
          invoiceType={{invoiceType, setInvoiceType}}
          invoiceTemplate={{invoiceTemplate, setInvoiceTemplate}}
          action={{
            excelModal: excelModalOpen,
            setExcelModal: setExcelModalOpen,
          }}
        />
      )}
      {newWebModalOpen && (
        <InvoiceEditModal
          title={{title, setTitle}}
          invoiceType={{invoiceType, setInvoiceType}}
          invoiceTemplate={{invoiceTemplate, setInvoiceTemplate}}
          closeFn={() => {
            setNewWebModalOpen(false)
          }}
        />
      )}
    </div>
  )
}

export {InvoiceTypeFavDashboard}
